export default "__VITE_ASSET__$Bf$hFhR__"